export const TreatmentMixin = {
    components: {

    },
    created() {

    }
}
